import { Component, OnInit } from '@angular/core';
import {FormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import { AuthenticationService } from '../services/authentication.service';
import { PersonalService } from '../services/personal.service';
import { RoleService } from '../services/role.service';
import { PermissionStorageService } from '../storages/permission-storage.service';
import { TokenStorageService } from '../storages/token-storage.service';
import { TenantSettingsStoreService } from 'src/app/setting/tenant-settings/services/tenant-settings-store.service';
import { UserSettingsStoreService } from 'src/app/user-settings/services/user-settings-store.service';
import { appVersion } from 'src/environments/version';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { VersionService } from 'src/app/core/services/version.service';
import { IVersion } from 'src/app/core/models/version';
import { AppStateInterface } from 'src/app/stores/global/appState.interface';
import { Store } from '@ngrx/store';
import { getCurrentEmployee } from 'src/app/stores/global/current-employee/current-employee.store';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { translate } from '@jsverse/transloco';

@UntilDestroy()
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(
    private router: Router,
    private authenticationService : AuthenticationService,
    private tokenStorage : TokenStorageService,
    private personalService : PersonalService,
    private permissionStorage : PermissionStorageService,
    private tenantSettingsStore : TenantSettingsStoreService,
    private userSettingsStore: UserSettingsStoreService,
    private versionService: VersionService,
    private store: Store<AppStateInterface>,
    private appnotificationService: AppNotificationService
  ) { }

  isLoading = false;

  version = appVersion.version;

  backendVersion : IVersion;

  loginForm = new UntypedFormGroup({
    tendantId: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', Validators.required),
    password: new UntypedFormControl('', Validators.required)
  });

  ngOnInit(): void {
    // set tenantId that is save in the localstorage
    if(this.tokenStorage.getTenantId){
      const tenantId = this.tokenStorage.getTenantId();
      this.loginForm.patchValue({
        tendantId: tenantId
      })
    }

    this.versionService.getVersion()
      .pipe(untilDestroyed(this))
      .subscribe(response => this.backendVersion = response)

  }

  onSubmit(){
    this.isLoading = true;
    const formValues = this.loginForm.value;
    this.authenticationService.signIn(formValues, formValues.tendantId)
      .subscribe(response => {
          this.tokenStorage.saveToken(response.token);
          this.tokenStorage.saveRefreshToken(response.refreshToken);
          this.tokenStorage.saveTenantId(formValues.tendantId);
          this.store.dispatch(getCurrentEmployee());
          this.tenantSettingsStore.getCurrentTenantSettings();
          this.userSettingsStore.getCurrentUserSettings();
          this.personalService.getPermissionOfCurrentUser()
          .subscribe(permissions => {
            this.permissionStorage.savePermissions(permissions);
            this.router.navigate(['/']);
            this.isLoading = false
          },
          error => this.isLoading = false
          )
      },
      error => {
        this.isLoading = false;
        // Same message for wrong tenant, e-mail or password; other errors are already notified by the interceptor.
        if (error?.status === 401) {
          this.appnotificationService.notification$.next({ message: translate('auth.loginFailed'), style: 'error' });
        }
      })
  }

}
